import { Alert, AlertContainer } from "react-bs-notifier";
import React from "react";
import { connect } from "react-redux";
import { clearAlerts } from "../../store/WriteClass";

let AlertComponent = ({ alerts, clearAlerts }) => {
  let alertComponents = alerts.map((alert, i) => {
    const { message, ...rest } = alert;
    return (
      <Alert onDismiss={clearAlerts} {...rest} key={i}>
        {message}
      </Alert>
    );
  });

  return (
    <AlertContainer position="top-right">{alertComponents}</AlertContainer>
  );
};

const mapStateToProps = state => ({ alerts: state.write_class.alerts });
const mapDispatchToProp = dispatch => ({
  clearAlerts: () => dispatch(clearAlerts())
});
export default connect(
  mapStateToProps,
  mapDispatchToProp
)(AlertComponent);



// WEBPACK FOOTER //
// ./src/components/alerts/index.jsx